/**
 * @generated SignedSource<<36c478dbc6b11c49d2fb8ad998c8c122>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteLicenseInput = {
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
};
export type deleteLicenseButton_DeleteLicenseMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteLicenseInput;
};
export type deleteLicenseButton_DeleteLicenseMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly deleteLicense: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null;
    };
  };
};
export type deleteLicenseButton_DeleteLicenseMutation = {
  response: deleteLicenseButton_DeleteLicenseMutation$data;
  variables: deleteLicenseButton_DeleteLicenseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteLicenseButton_DeleteLicenseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteLicensePayload",
                "kind": "LinkedField",
                "name": "deleteLicense",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "deleteLicenseButton_DeleteLicenseMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteLicensePayload",
                "kind": "LinkedField",
                "name": "deleteLicense",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a50ff7fbd45cb99a87bc748ddc530bd1",
    "id": null,
    "metadata": {},
    "name": "deleteLicenseButton_DeleteLicenseMutation",
    "operationKind": "mutation",
    "text": "mutation deleteLicenseButton_DeleteLicenseMutation(\n  $input: DeleteLicenseInput!\n) {\n  Admin {\n    Billing {\n      deleteLicense(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f9fb436234ca81d57c1c4ab740d552d";

export default node;
